import script from "./TutorOnboarding.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorOnboarding.vue?vue&type=script&setup=true&lang=js"

import "./TutorOnboarding.vue?vue&type=style&index=0&id=4eaecc1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eaecc1c"]])

export default __exports__